/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_ImagesInputs */

const zh_sidebar_images = /** @type {(inputs: Sidebar_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片`)
};

const en_sidebar_images = /** @type {(inputs: Sidebar_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const es_sidebar_images = /** @type {(inputs: Sidebar_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes`)
};

/**
* | output |
* | --- |
* | "Images" |
*
* @param {Sidebar_ImagesInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_images = /** @type {((inputs?: Sidebar_ImagesInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_ImagesInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_images(inputs)
	if (locale === "en") return en_sidebar_images(inputs)
	return es_sidebar_images(inputs)
});